import { type CellContext, RowActionsWrapper } from "@msuite/ui/table";
import type { SubstitutionPlanFormItemSchema } from "@msuite/utils/schemas";

export function RowActions({ cell }: CellContext<SubstitutionPlanFormItemSchema, "actions">) {
	/** Render */
	return (
		<RowActionsWrapper
			to={`/projects/${cell.row.original.projectId}`}
			forceBlank
		/>
	);
}
